import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { ClientfinalCraService } from './../../../../../core/services/clientfinal-cra/clientfinal-cra.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  serverError,
  successAddworkfloww,
} from './../../../../../core/models/messages';
import { EsnpermissionService } from './../../../../../core/services/esnpermission/esnpermission.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-updateworkfloqclient',
  templateUrl: './updateworkfloqclient.component.html',
  styleUrls: ['./updateworkfloqclient.component.css'],
})
export class UpdateworkfloqclientComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  listrole: any;
  roleConsultant:string="Collaborateur"

  id = this.activatedRoute.snapshot.params['id'];
  name = [
    { id: '1', name: 'Consultant' },
    { id: '2', name: 'Responsable' },
    { id: '3', name: 'RH' },
  ];
  state = [
    { id: '1', name: 'Validé' },
    { id: '2', name: 'Rejeté' },
  ];
  selectedworkflow: any;
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraclient: ClientfinalCraService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private roleservice: EsnpermissionService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.getId();
    this.getWorkflowById();
    this.getListrole();
    this.updateRoleValidators();
  }
  createFormssubWorkFlows(data?: any): FormGroup {
    return this.formBuilder.group({
      custom_role_id: [data ? data.custom_role_id : null],
      step: [data ? data.step : '1'],
    });
  }
  
  validateUniqueRole(index: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const subWorkFlowTimeSheets = this.formWorkFlow?.get('subWorkFlowTimeSheets') as FormArray;
      const selectedRoleId = control.value;
  
      if (!selectedRoleId) {
        return null;
      }
  
      let isDuplicate = false;
      subWorkFlowTimeSheets?.controls.forEach((formGroup, i) => {
        if (i !== index && formGroup.get('custom_role_id')?.value === selectedRoleId) {
          isDuplicate = true;
        }
      });
  
      return isDuplicate ? { duplicateRole: true } : null;
    };
  }
  
  
  createWorkFlowForm(data?: any) {
    return this.formBuilder.group({
      company_id_specific: [data?.company_id_specific || ''],
      consultant_id: [data?.consultant_id || ''],
      state_workflow: [data?.state_workflow || ''],
      subWorkFlowTimeSheets: this.formBuilder.array(
        Array.isArray(data?.sub_work_flow_time_sheet) &&
          data?.sub_work_flow_time_sheet.length
          ? data.sub_work_flow_time_sheet.map((item: any) =>
              this.createFormssubWorkFlows(item)
            )
          : [this.createFormssubWorkFlows()]
      ),
    });
  }

  /* create workflow general*/
  updateWorkflow() {
    this.spinner.show();
    this.serviceCraclient
      .updateWorkflow(this.id, this.formWorkFlow.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', this.formWorkFlow.value);
          this.spinner.hide();
          this.router.navigate(['/cra/workflow-Timesheet']);
          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }
  addsubWorkFlows(): void {
    const subWork = this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray;
    const newFormGroup = this.createFormssubWorkFlows();
    subWork.push(newFormGroup);
    this.updateRoleValidators();
  }
  updateRoleValidators(): void {
    const subWorkFlowTimeSheets = this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray;
    
    subWorkFlowTimeSheets.controls.forEach((formGroup, index) => {
      formGroup.get('custom_role_id')?.setValidators(this.validateUniqueRole(index));
      formGroup.get('custom_role_id')?.updateValueAndValidity();  // Reapply validation
    });
  }
  removesubWorkFlows(index: number) {
    const skills = this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray;
    skills.removeAt(index);
    this.updateRoleValidators();
  }
  get subWorkFlowsControls(): AbstractControl[] {
    return (this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray)?.controls || [];
  }
  ResetForm() {
    this.formWorkFlow.reset();
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
      },
    });
  }
  getListrole() {
    this.roleservice.getlisterolesUpdate().subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data) {
          this.listrole = response.data.data;
          console.log('list roles', this.listrole);
        }
      },
      error: (error) => {
        console.error('Error fetching roles: ', error);
      },
    });
  }
  getWorkflowById() {
    this.spinner.show();
    this.serviceCraclient
      .getWorkflowdetail(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('resworkflow detail ', res);
          this.selectedworkflow = res.data;
          console.log('resworkflow detail sqds ', this.selectedworkflow);
          console.log('reswl sqds ', this.selectedworkflow.name);
          this.formWorkFlow = this.createWorkFlowForm(this.selectedworkflow);
          console.log('this formworkflow', this.formWorkFlow.value.name);

          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
}
